let data = {
    see: 'manual',
    redes: {
      links: {
        linkFace: 'https://www.facebook.com/SATE.nacional?fref=ts',
        linkX: 'https://twitter.com/SATE_oficial',
        linkIG: 'https://www.instagram.com/sateargentina/',
        linkYouT: 'https://www.youtube.com/canalsate',
      },
      textoRedes: 'SATE',
      hashtag: 'sate',
      isDark: false
    }
}

export const store = data